// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_1sBfjgFSd1G5ixdE4_fJbu","text":"_2U0eRM-UKT8kkpWUEsPUZx","tab":"OK0-4Y3YaV2H5Z-8u4R1K","underline":"_3qHamai1OAGKK2KuYoDgvP"};